

import { Box } from "@mui/material"
import Header from "./components/header"
import BottomBar from "./components/bottombar"
import { useMediaQuery } from "react-responsive"
import Sidebar from "./components/sidebar"
import Address from "./components/address_modal"
import AdminSidebar from "./components/adminSideBar"
import Cart from "./components/cart"
import { useEffect } from "react"

import { jwtDecode } from 'jwt-decode';
import { useDispatch } from "react-redux"
import { useLocation } from "react-router-dom"
import { updateFirstName, updateLastName, updateEmail, updateRole, updateId, updateAllAddress,updateMemberResponse, updateUserName, updateMobile,updateWhatsapp, updateAccumulated,updateGetBank,updateWithdrawRequest,updateMembership,updateConrtol, updatePlanSubscribed, updateMultiple, updateMultipleAccount, updateSwitchedAccount, updateIsDetailsLoading } from "./redux/user_reducer"
import { updateCart } from "./redux/products"
import CustomAxios from "./utils/CustomAxios"
import { updateProfile } from "./redux/user_reducer"
import CartSideMount from "./components/cartSideMount"
import { TransactionPinVerification } from "./modules/transactionPIN_verify"
import BankForm from "./modules/bankForm"
import Header1 from "./components/header1"
import MpinOverlay from "./components/MpinOverlay"

let lastDetailsFetchAt = 0
let lastDetailsFetchPath = ""
let lastDetailsFetchUserId = null
const Layout = () => {
    const isMobile = useMediaQuery({ maxWidth: 600 });
    const isLaptop = useMediaQuery({ query: '(min-width: 900px)' });

    const authtoken = localStorage.getItem("authtoken")
    const add=localStorage.getItem('address')
    // // console.log(authtoken)
    const dispatch = useDispatch()
    const location = useLocation()

    useEffect(() => {
        if (authtoken) {
            
            const decode = jwtDecode(authtoken)
            dispatch(updateFirstName(decode.first_name))
            dispatch(updateLastName(decode.last_name))
            dispatch(updateEmail(decode.email))
            // console.log("decoding user role")
            dispatch(updateRole(decode.role))
            dispatch(updateConrtol(decode.control))
            dispatch(updateId(decode.id))
            // Legacy cart bootstrap disabled for video-subscription-only flow testing.
            // handleCart()
        }
        // // console.log(add)
        if(add && add !== "undefined"){
            try {
                dispatch(updateAllAddress(JSON.parse(add)))
            } catch (e) {
                // Handle invalid JSON (e.g., old "undefined" string)
                localStorage.setItem("address", JSON.stringify([]))
                dispatch(updateAllAddress([]))
            }
        }
        if (localStorage.getItem("cart")&&!authtoken) {
            // // console.log(localStorage.getItem("cart"))
            const cart = localStorage.getItem("cart")
            // // console.log(cart)
            dispatch(updateCart(JSON.parse(localStorage.getItem("cart"))))
        }
        else {
            // // console.log("added")
            localStorage.setItem("cart", JSON.stringify([]))
        }
        

    }, [authtoken,add])

    useEffect(() => {
        if (!authtoken){
            return
        }
        const shouldRefresh =
            location.pathname === "/dashboard" ||
            location.pathname === "/my_networth" ||
            location.pathname === "/checkout" ||
            location.pathname === "/products" ||
            location.pathname.startsWith("/product_details/")

        if (!shouldRefresh){
            return
        }

        const decode = jwtDecode(authtoken)
        const now = Date.now()
        const sameRequest =
            lastDetailsFetchUserId === decode.id &&
            lastDetailsFetchPath === location.pathname &&
            now - lastDetailsFetchAt < 1500

        if (sameRequest){
            return
        }

        fetchuserdetails(decode.id, location.pathname)
    }, [authtoken, location.pathname])

    
          const fetchuserdetails = async (userid, pathContext = "") => {
            // // console.log("id", id)
            const payload = {
                user_id: userid
            }
            if (userid){
                dispatch(updateIsDetailsLoading(true))
                const isProductRoute =
                    pathContext === "/products" || pathContext.startsWith("/product_details/")
                const detailsEndpoint =
                    (pathContext === "/dashboard" || pathContext === "/my_networth")
                        ? "dashboard-details/"
                        : isProductRoute
                            ? "profile-details/"
                            : "get_details/"
                await CustomAxios.post(detailsEndpoint, payload).then(response => {
                    lastDetailsFetchAt = Date.now()
                    lastDetailsFetchPath = pathContext
                    lastDetailsFetchUserId = userid
                    // console.log(response.data)
                    dispatch(updateFirstName(response.data.user.first_name))
                    dispatch(updateLastName(response.data.user.last_name))
                    dispatch(updateEmail(response.data.user.email))
                    dispatch(updateUserName(response.data.user.username))
                    dispatch(updateMobile(response.data.user.mobileno))
                    // dispatch(updateRole(decode.role))
                    dispatch(updateWhatsapp(response.data.user.whatsapp))
                    dispatch(updateId(response.data.user.id))
                    dispatch(updateMemberResponse(response.data))
                    dispatch(updateProfile(response.data.att?.original))
                    // dashboard-details/ may omit accumulated; avoid wiping Redux with undefined
                    if (response.data.accumulated != null) {
                        dispatch(updateAccumulated(response.data.accumulated))
                    }
                    dispatch(updateGetBank(response.data.bankdetails))
                    dispatch(updateWithdrawRequest(response.data.withdrawRequest))
                    dispatch(updateMembership(response.data.user.member))
                    dispatch(updatePlanSubscribed(response.data.subscribedplan))
                    dispatch(updateMultiple(response.data.multiple))
                    dispatch(updateMultipleAccount(response.data.multipleAccounts))
                    dispatch(updateSwitchedAccount(response.data.multipleAccounts.filter(acc=>acc.id==userid)))
                    dispatch(updateIsDetailsLoading(false))
                }
                ).catch(error => {
                    // console.log(error)
                    dispatch(updateIsDetailsLoading(false))
                })
            }
            
        }
    // const handleCart=async()=>{
    //     const decode = jwtDecode(authtoken)
    //     const response = await CustomAxios.get(`usercart/${decode.id}`,)
    //     dispatch(updateCart(response.data))
    //     localStorage.setItem("cart", JSON.stringify(response.data))
    // }
    
    

    return <Box sx={{ bgcolor: { sm: "grey.200", xs: "#fff", } }}>
        <Header1 />
        {!isLaptop&&authtoken && <BottomBar />}
        <Sidebar />
        <Address />
        <BankForm/>
        <TransactionPinVerification/>
        <CartSideMount/>
        <Cart />
        <MpinOverlay/>

    </Box>


}
export default Layout
